import { Download, RefreshCw } from "lucide-react";

export default function PayoutFilters({
  minValue, setMinValue,
  tipoCliente, setTipoCliente,
  onlyAvailable, setOnlyAvailable,
  setPage, onRefresh, onExport,
  loading, hasRows,
}) {
  return (
    <div className="bg-white border border-[#E6E1D6] rounded-md p-4 mb-3 flex flex-wrap items-end gap-3">
      <div className="flex flex-col gap-1">
        <label className="text-[10px] uppercase tracking-[0.15em] text-[#978D78] font-bold">Valor mínimo</label>
        <input type="number" step="0.01" value={minValue}
          onChange={(e) => { setPage(1); setMinValue(e.target.value); }}
          className="px-3 py-2 text-sm border border-[#E6E1D6] rounded w-28 outline-none focus:border-[#0F1829] font-mono"
          data-testid="filter-min-value" />
      </div>
      <div className="flex flex-col gap-1">
        <label className="text-[10px] uppercase tracking-[0.15em] text-[#978D78] font-bold">Tipo Cliente</label>
        <input type="text" value={tipoCliente} placeholder="ex: CS"
          onChange={(e) => { setPage(1); setTipoCliente(e.target.value); }}
          className="px-3 py-2 text-sm border border-[#E6E1D6] rounded w-24 outline-none focus:border-[#0F1829] font-mono"
          data-testid="filter-tipo-cliente" />
      </div>
      <label className="flex items-center gap-2 text-sm cursor-pointer select-none" data-testid="filter-only-available">
        <input type="checkbox" checked={onlyAvailable}
          onChange={(e) => { setPage(1); setOnlyAvailable(e.target.checked); }} />
        <span>Só disponíveis <span className="text-[#9CA3AF]">(excl. mês actual)</span></span>
      </label>
      <div className="ml-auto flex items-end gap-2">
        <button onClick={onRefresh} disabled={loading}
          className="px-3 py-2 text-sm border border-[#E6E1D6] rounded hover:bg-[#F5F2EB] flex items-center gap-1 disabled:opacity-40"
          data-testid="btn-refresh">
          <RefreshCw size={13} className={loading ? "animate-spin" : ""} /> Actualizar
        </button>
        <button onClick={onExport} disabled={!hasRows}
          className="px-3 py-2 text-sm border border-[#E6E1D6] rounded hover:bg-[#F5F2EB] flex items-center gap-1 disabled:opacity-40"
          data-testid="btn-export-csv">
          <Download size={13} /> CSV
        </button>
      </div>
    </div>
  );
}
